import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, History, Eye, Download, Settings, Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';

export const Sidebar = () => {
  const location = useLocation();

  const menuItems = [
    { path: '/', label: 'Dashboard', icon: LayoutDashboard },
    { path: '/builds', label: 'Builds', icon: History },
    // { path: '/previews', label: 'Previews', icon: Eye },
    // { path: '/downloads', label: 'Downloads', icon: Download },
    { path: '/settings', label: 'Settings', icon: Settings }
  ];

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <motion.aside
      initial={{ x: -20, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      transition={{ duration: 0.3 }}
      className="fixed left-0 top-0 h-full w-64 bg-black/90 backdrop-blur-md border-r border-white/5 flex flex-col p-6 z-50 hidden md:flex"
      data-testid="sidebar"
    >
      <Link to="/" className="flex items-center gap-3 mb-12" data-testid="sidebar-logo">
        <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-primary to-accent flex items-center justify-center">
          <Sparkles className="w-6 h-6 text-white" />
        </div>
        <div>
          <h1 className="text-xl font-bold text-white" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
            TechSPR AI
          </h1>
          <p className="text-xs text-muted-foreground">AI App Builder</p>
        </div>
      </Link>

      <nav className="flex-1 space-y-2" data-testid="sidebar-nav">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          
          return (
            <Link
              key={item.path}
              to={item.path}
              data-testid={`nav-${item.label.toLowerCase()}`}
              className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                active
                  ? 'bg-primary/10 text-primary'
                  : 'text-muted-foreground hover:text-white hover:bg-white/5'
              }`}
            >
              <Icon className="w-5 h-5" />
              {item.label}
            </Link>
          );
        })}
      </nav>

      <div className="pt-6 border-t border-white/5">
        <div className="flex items-center gap-3 px-4 py-3" data-testid="user-profile">
          <img
            src="https://images.unsplash.com/photo-1615843423179-bea071facf96?auto=format&fit=crop&w=100&q=80"
            alt="User"
            className="w-8 h-8 rounded-full object-cover"
          />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-white truncate">Alex Morgan</p>
            <p className="text-xs text-muted-foreground truncate">alex@example.com</p>
          </div>
        </div>
      </div>
    </motion.aside>
  );
};
